export type AsoEbiOrder = {
  asoEbiID: string;
  description: string;
  purchaseUnitPrice: number;
  quantity: number;
};

export enum AsoEbiStatus {
  AsoEbiStatusOn = "on",
  AsoEbiStatusOff = "off",
}

export enum AsoEbiTransactionCostBearer {
  AsoEbiTransactionCostBearerCouple = "couple",
  AsoEbiTransactionCostBearerBuyer = "buyer",
}

export enum DisplayStatus {
  Shown = "shown",
  Hidden = "hidden",
}

export type AsoEbi = {
  _id: string;
  accountID: string;
  weddingID: string;
  coverImage: string;
  description: string;
  category: string;
  displayStatus: DisplayStatus;
  availableQty: number;
  price: number;
  quantityIssued: number;
  currentReservations: number;
  createdAt: Date;
  updatedAt: Date;
};

export type SettlementAccount = {
  _id: string;
  accountID: string;
  weddingID: string;
  bankID: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
  additionalInfo: string;
  subAccountID: string;
  createdAt: Date;
  updatedAt: Date;
};

export type Bank = {
  _id: string;
  name: string;
  slug: string;
  code: string;
  longcode: string;
  gateway: string;
  pay_with_bank: boolean;
  supports_transfer: boolean;
  active: boolean;
  country: string;
  currency: string;
  type: string;
  is_deleted: boolean;
  createdAt: Date;
  updatedAt: Date;
};

export enum TransactionCtx {
  TxCtxBuyPackage = "buypackage",
}

export enum TransactionInitiatorCtx {
  TxInitCtxAccount = "account",
}

export enum PaymentClient {
  PmtClientFlutterwave = "flutterwave",
  PmtClientPaystack = "paystack",
  PmtClientBudpay = "budpay",
}

export enum TransactionStatus {
  TxStatusSuccess = "success",
  TxStatusPending = "pending",
  TxStatusFailed = "failed",
}

export type Transaction = {
  _id: string;
  transactionCtx: TransactionCtx;
  transactionCtxID: string;
  transactionInitiatorCtx: TransactionInitiatorCtx;
  transactionInitiatorCtxID: string;
  transactionReference: string;
  paymentClientReference: string;
  paymentClient: PaymentClient;
  transactionStatus: TransactionStatus;
  amount: number;
  fee: number;
  createdAt: Date;
  updatedAt: Date;
};

export type BuyAsoEbiProps = {
  weddingID: string;
  asoEbiOrders: AsoEbiOrder[];
  fullName: string;
  email: string;
  phone: string;
  deliveryAddress: string;
  paymentClient: PaymentClient;
};
